module.exports = __webpack_public_path__ + "img/Norte.f8e8af09.png";